import React, { useState } from 'react';
import { StyledCardWrapper } from './LiveSupportCard.styles';
import { Card } from '@sections/registry/components';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import { LazyLoadWrapper } from '@components/LazyLoadWrapper';
import { useTranslation } from 'react-i18next';

export const LiveSupportCard = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation('registry');
  const liveSupportCard = t('guestExperienceSection.liveSupportCard');

  return (
    <StyledCardWrapper>
      <LazyLoadWrapper beforeLoad={() => setIsVisible(true)}>
        <></>
      </LazyLoadWrapper>
      <Card
        eyebrow={liveSupportCard.eyebrow}
        eyebrowVariant="featureHed17"
        eyebrowColor="white"
        title={liveSupportCard.title}
        titleVariant="calloutHed32"
        titleColor="white"
        wrapperStyles={{
          background: `url(${
            isVisible ? cloudAssetUrl('registry-q12024/better-for-guests/bkg-livesupport@2x.jpg', { optimization: 'default' }) : ''
          }) center / cover no-repeat, linear-gradient(0deg, rgba(0, 0, 0, 0.30) 0%, rgba(0, 0, 0, 0.30) 100%), lightgray 50%`,
        }}
      />
    </StyledCardWrapper>
  );
};
